import 'bootstrap/js/dist/scrollspy';
import('./pb-scrollspy-v2.css');

const pbScrollspyV2 = {
    init: function () {
        var refElement = $('.pb-scrollspy-v2').data('ref');
        var fixOffset = $('.pb-scrollspy-v2').data('fixoffset');
        var heightRef = - $('#pbscrollspynav').height();
        var top = 500;
        var lastScrollOffset = 0;
        $(refElement).each(function() {
            if ($(this).offset().top < top)
                top = $(this).offset().top;
            heightRef += $(this).height();
        });
        heightRef += top;
        if (!heightRef)
        {
            heightRef = 400;
        }
        if (typeof fixOffset != 'undefined')
        {
            heightRef = heightRef - parseInt(fixOffset);
        }
        $('body').scrollspy({ target: '#pbscrollspynav', offset: 166 });

        
        $('#pbscrollspynav ul li a[href*="#"]').on('click', function(e)
        {
            e.preventDefault();
            var anch = $(this).attr('href');
            var fix = $(this).data('scrollfix');
            if (typeof fix == 'undefined')
                fix = 0;
            $('html, body').animate({
                scrollTop: $(anch).offset().top - 120 + fix
            }, 500);
            return false;
        });
        

        $(window).scroll(function () {
            if (window.scrollY > heightRef)
            {
                $('#pbscrollspynav').addClass('fixed');
                $('.pb-scrollspy-v2').addClass('fixed');

            } else
            {
                $('#pbscrollspynav').removeClass('fixed');
                $('.pb-scrollspy-v2').removeClass('fixed');

            }
            if(pbScrollspyV2.lastScrollOffset > window.scrollY){ /** Scrolling upward */
                $('#pbscrollspynav').removeClass('second-nav-level');
            }else{ /** Scrolling downward */
                $('#pbscrollspynav').addClass('second-nav-level');
            }
            pbScrollspyV2.lastScrollOffset = window.scrollY;
        });
        if (window.scrollY > heightRef)
        {
            $('#pbscrollspynav').addClass('fixed');
        } else
        {
            $('#pbscrollspynav').removeClass('fixed');
        }
    }
}

// initialize component
window.loadedComponents.push({ component: 'pb-scrollspy-v2', init: pbScrollspyV2.init});

export default() => {
    pbScrollspyV2.init();
}